<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='学员奖金汇总统计' url='/report/payment/stu/section'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">开始时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.grantbeginyear" type="month" placeholder="开始时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">结束时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.grantendyear" type="month" placeholder="结束时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <div v-html="tableData">
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentStuSection',
  data () {
    return {
      condition: {
        token: '',
        truename: '',
        cardno: '',
        grantbeginyear: '',
        grantendyear: ''
      },
      tableData: null,
      searchUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuPaymentList',
      exportUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuPaymentListOut'
    }
  },
  created () {
    window.Info = this.Info
  },
  methods: {
    Info: function (stuid, stuname) {
      this.$router.push({name: 'PaymentStuUser', params: {id: stuid, name: stuname}})
    }
  },
  mounted: function () {
    var date = new Date()
    var year = date.getFullYear()
    this.condition.grantbeginyear = String(year) + "-1"
    this.condition.grantendyear = String(year) + "-12"
    this.condition.token = sessionStorage.getItem('token')
    this.$refs.btnSearch.Search()
  }
}
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>

<style scoped="scoped">
  @import '../../../../assets/css/achievementinfo.css'
</style>
